
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CheckOrgUsersList/CheckOrgUsersList.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CheckOrgUsersList.html');
        
        var script = require('./CheckOrgUsersList.ts').default;
        module.exports = require('./CheckOrgUsersList.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    